import { createFileRoute, useNavigate, useParams } from '@tanstack/react-router';

import { VideoCallScreen } from '@/features/video/components/VideoCallScreen';
import { isStaffCallPopupTab } from '@/features/video/lib/openSessionCallTab';
import { requirePermission } from '@/lib/guards';

export const Route = createFileRoute('/_staff-fullscreen/admin/workspace/sessions/$sessionId/call')(
  {
    beforeLoad: () => {
      requirePermission('session:read');
    },
    component: VideoCallRoute,
    staticData: { crumb: 'Call' },
  },
);

export function VideoCallRoute() {
  const { sessionId } = useParams({
    from: '/_staff-fullscreen/admin/workspace/sessions/$sessionId/call',
  });
  const navigate = useNavigate();

  const exitOrClose = (fallback: () => void) => {
    if (isStaffCallPopupTab()) {
      window.close();
    }
    fallback();
  };

  return (
    <VideoCallScreen
      sessionId={sessionId}
      onExit={() => {
        exitOrClose(() => {
          void navigate({
            to: '/admin/workspace/sessions/$sessionId',
            params: { sessionId },
          });
        });
      }}
      onPostSessionRedirect={() => {
        exitOrClose(() => {
          void navigate({
            to: '/app/sessions',
            search: {
              panel: 'session' as const,
              id: sessionId,
              drawerTab: 'notes' as const,
              segment: 'all' as const,
            },
          });
        });
      }}
    />
  );
}
